var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 24,
    viewBox: "0 0 75 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9449 4.97877V0.829834H0V23.1703H5.18917V15.032H15.5675V10.883H5.18917V4.97877H16.9449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4579 23.1703H25.6471V0.829834H20.4579V23.1703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4078 0.829834V14.3937L35.2606 0.829834H30.9684V23.1703H36.0935V9.60643L47.2726 23.1703H51.5329V0.829834H46.4078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2513 18.9575L74.5195 4.1809V0.829834H55.6527V5.0426H67.6967L55.3965 19.8192V23.1703H75V18.9575H62.2513Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be4c2ba1babb7e291e4e6c1dde312043.svg";
export { ForwardRef as ReactComponent };